import React from 'react';
import { SaveSpinner } from '@/components/ui/Icons/SaveSpinner';
import designTokens from '@/design-tokens';

interface LoadingScreenProps {
  title?: string;
  message?: string;
  showRetry?: boolean;
  onRetry?: () => void;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  title = "Loading",
  message = "Please wait while we load your workspace...",
  showRetry = false,
  onRetry
}) => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
      padding: '2rem'
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%'
      }}>
        {/* Loading spinner */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '2rem'
        }}>
          <SaveSpinner
            width={48}
            height={48}
            color={designTokens.surface?.brand?.primary || '#2bb673'}
          />
        </div>

        {/* Title */}
        <h2 style={{
          fontFamily: designTokens.font?.family?.primary || 'Montserrat, system-ui, sans-serif',
          fontSize: designTokens.font?.size?.xl || '1.25rem',
          fontWeight: designTokens.font?.weight?.semibold || '600',
          lineHeight: designTokens.font?.['line-height']?.lg || '1.75rem',
          color: designTokens.text?.primary || '#111827',
          margin: '0 0 0.75rem 0'
        }}>
          {title}
        </h2>

        {/* Message */}
        <p style={{
          fontFamily: designTokens.font?.family?.primary || 'Montserrat, system-ui, sans-serif',
          fontSize: designTokens.font?.size?.base || '1rem',
          fontWeight: designTokens.font?.weight?.regular || '400',
          lineHeight: designTokens.font?.['line-height']?.md || '1.5rem',
          color: designTokens.text?.secondary || '#6b7280',
          margin: '0 0 2rem 0'
        }}>
          {message}
        </p>

        {/* Optional retry button */}
        {showRetry && onRetry && (
          <button
            onClick={onRetry}
            style={{
              fontFamily: designTokens.font?.family?.primary || 'Montserrat, system-ui, sans-serif',
              fontSize: designTokens.font?.size?.sm || '0.875rem',
              fontWeight: designTokens.font?.weight?.medium || '500',
              padding: '0.75rem 1.5rem',
              backgroundColor: designTokens.surface?.brand?.primary || '#2bb673',
              color: 'white',
              border: 'none',
              borderRadius: designTokens['button/radius'] || '1.5rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = designTokens.surface?.brand?.['primary-hover'] || '#229a5f';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = designTokens.surface?.brand?.primary || '#2bb673';
            }}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};